import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardAttributeDb } from '../redux/cardAttributeDbSlice';
import { CardShapeDb } from '../redux/cardShapeDbSlice';

const useCardAttributeDbs = (cardId: string | undefined): [string[], (CardAttributeDb | CardShapeDb)[]] => {
  const cardAttributeDb = useSelector((state: RootState) => state.cardAttributeDb);
  const cardShapeDb = useSelector((state: RootState) => state.cardShapeDb);
  const itemIds = Object.keys(cardAttributeDb.cardAttributes).filter(id => cardAttributeDb.cardAttributes[id].cardId === cardId);
  const shapeIds = Object.keys(cardShapeDb.cardShapes).filter(id => cardShapeDb.cardShapes[id].cardId === cardId);
  const ids = itemIds.concat(shapeIds);
  ids.sort((a, b) => {
    const aValue = cardAttributeDb.cardAttributes[a] || cardShapeDb.cardShapes[a];
    const bValue = cardAttributeDb.cardAttributes[b] || cardShapeDb.cardShapes[b];
    return bValue.z - aValue.z;
  })
  const values = ids.map(id => {
    return cardAttributeDb.cardAttributes[id] || cardShapeDb.cardShapes[id];
  });

  return [ids, values];
}

export default useCardAttributeDbs;
